import { ViewportType } from 'game-ui-types'
import { ViewportConfigurations } from './types'

// Config E (no Bet Slider)
export const slotConfigE: ViewportConfigurations = {
    [ViewportType.MOBILE_PORTRAIT]: {
        SpinButtonSection: {
            position: { bottom: '90px' },
            styles: 'gap-[10px] items-center [zoom:0.8] left-0 right-0 w-max mx-auto',
        },
        SpinButtonSectionLeftHand: {
            position: { top: '1172px', left: '193px' },
        },
        SpinButtonGambleSection: {
            position: { top: '1277px', left: '219px' },
            styles: 'gap-[10px] items-start [zoom:0.9]',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { top: '1172px', left: '193px' },
        },
        SpinButton: {
            styles: '',
        },
        StopButton: {
            position: { top: '502px', left: '0' },
            styles: 'bg-black fixed w-full h-[34%] z-[0]',
        },
        BetOptionButton: {
            styles: '',
        },
        BetOptionSection: {
            position: { bottom: '273px' },
            styles: 'left-1/2 transform -translate-x-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            styles: '',
        },
        AutoplaySection: {
            position: { bottom: '175px', left: '-20px' },
            styles: 'absolute bg-[#131313]',
        },
        AutoplaySectionLeftHand: {
            position: { bottom: '220px', left: '-20px' },
        },
        SpeedButton: {
            position: { bottom: '-45px', left: '50%' },
            styles: 'absolute translate-x-[-50%] z-[51]',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { top: '1134px', left: '5px' },
            dimensions: { width: '176px' },
            styles: 'ml-[0px] [zoom:0.9] z-[1]',
        },
        PlayerInfoBalanceFeature: {
            position: { bottom: '45px', left: '112px' },
            dimensions: { width: '176px' },
            styles: 'ml-[0px] [zoom:0.9] z-[1]',
        },
        PlayerInfoBalanceLabel: {
            dimensions: { fontSize: '24px' },
        },
        PlayerInfoBalanceLabelFeature: {
            dimensions: { fontSize: '18px' },
        },
        PlayerInfoBalanceJackpot: {
            position: { bottom: '58px', left: '112px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoBalanceGamble: {
            position: { bottom: '136px', left: '8px' },
            dimensions: { width: '250px' },
            styles: 'ml-0 flex-row',
        },
        PlayerInfoLastWin: {
            dimensions: { width: '176px' },
            position: { top: '1134px', right: '0px' },
            styles: 'flex-col  ml-[0px] [zoom:0.9] z-[1]',
        },
        PlayerInfoLastWinFeature: {
            dimensions: { width: '176px' },
            position: { bottom: '262px' },
            styles: 'flex-col ml-[0px] [zoom:0.9] z-[1] left-1/2 -translate-x-1/2',
        },
        PlayerInfoLastWinGamble: {
            position: { bottom: '136px', right: '8px' },
            dimensions: { width: '180px' },
            styles: 'ml-0 flex-row justify-end',
        },
        PlayerInfoWinLabel: {
            styles: 'text-[18px] leading-[24px]',
        },
        PlayerInfoCurrencyLabel: {
            styles: '',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-col items-center',
        },
        PlayerInfoExternalBetAmount: {
            styles: '',
            position: { bottom: '142px', right: '16px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoExternalBetAmountFeature: {
            styles: '',
            position: { bottom: '41px', right: '101px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            dimensions: { width: '172px' },
        },
        BetSlider: {
            position: { bottom: '316px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '127px', right: '16px' },
        },
        DoubleChanceButtonNoAmuseBoost: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '127px', left: '16px' },
        },
        DoubleChanceButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { top: '4px', right: '0px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '144px', right: '16px' },
        },
        BuyBonusButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { bottom: '17px', right: '0px' },
        },
        AmuseBoostButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '140px', right: '16px' },
        },
        AmuseBoostModal: {
            dimensions: { width: '132px', height: '274px' },
            position: { bottom: '301px', right: '16px' },
        },
        PromoWidget: {
            position: { bottom: '132px', left: '16px' },
            dimensions: { width: '140px', height: '168px' },
        },
        Navigation: {
            styles: 'px-[16px] flex justify-between items-end',
            position: { bottom: '40px' },
        },
        NavigationLeftWrapper: {
            styles: '',
        },
        NavigationRightWrapper: {
            styles: 'flex flex-col gap-[20px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[14px] leading-[18px]',
        },
        ComplianceColLeft: {
            styles: '',
        },
        ComplianceColCenter: {
            styles: '',
        },
        ComplianceColRight: {
            styles: '',
        },
        CustomResult: {
            position: { top: '202px', left: '5px' },
            styles: 'absolute w-[35px] h-[35px] z-[200]',
        },
        InfoLine: {
            position: { top: '1016px' },
            styles: 'absolute h-[98px] w-[810px] flex justify-center items-center text-center translate-x-[-50%] left-[50%] bg-winline-gradient',
        },
        InfoLineJackpot: {
            position: { top: '980px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'w-full flex gap-[16px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[30px] w-[324px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[30px] w-[600px] text-white text-center font-bold',
        },
        JackpotBoxes: {
            styles: 'gap-[14px]',
        },
        JackpotHistory: {
            position: { top: '170px' },
            dimensions: { height: '1267px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '232px' },
        },
        BetStepper: {
            styles: 'absolute left-1/2 transform -translate-x-1/2',
            position: { bottom: '238px' },
        },
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        SpinButtonSection: {
            position: { top: '176px', right: '-9px' },
            dimensions: { width: '251px' },
            styles: 'flex-row flex-wrap gap-[0px] items-center content-end justify-center [zoom:0.9]',
        },
        SpinButtonSectionLeftHand: {
            position: { bottom: '372px', left: '0px' },
        },
        SpinButtonGambleSection: {
            position: { top: '176px', right: '0px' },
            dimensions: { width: '251px', height: '369px' },
            styles: 'flex-row-reverse flex-wrap gap-[11px] items-center content-end justify-center',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { bottom: '372px', left: '0px' },
        },
        SideButton: {
            styles: 'scale-[0.9] mr-[-2px]',
        },
        SpinButton: {
            styles: 'order-[3] [zoom:0.9]',
        },
        StopButton: {
            position: { top: '80px', left: '245px' },
            styles: 'bg-black fixed w-[65%] h-[74%] z-[0]',
        },
        BetOptionButton: {
            // styles: 'scale-[0.9]',
        },
        BetOptionSection: {
            styles: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            // styles: 'scale-[0.9] mr-[-2px]',
        },
        AutoplaySection: {
            position: { top: '-7px', right: '251px' },
            styles: 'absolute bg-[#131313] scale-[0.9]',
        },
        AutoplaySectionLeftHand: {
            position: { top: '35px', left: '270px' },
        },
        SpeedButton: {
            position: { bottom: '-30px' },
            styles: 'absolute z-[51] mt-[-25px] flex scale-[0.9]',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { bottom: '25px', left: '245px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoLastWin: {
            dimensions: { width: '224px' },
            position: { bottom: '25px', right: '248px' },
            styles: 'flex-col',
        },
        PlayerInfoWinLabel: {
            styles: '',
        },
        PlayerInfoCurrencyLabel: {
            styles: '',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-col items-center',
        },
        PlayerInfoExternalBetAmount: {
            styles: 'rounded-[100px] bg-black/50 scale-[0.85] origin-bottom-right',
            position: { bottom: '24px', right: '634px' },
            dimensions: { width: '172px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            dimensions: { width: '172px' },
        },
        BetSlider: {
            position: { bottom: '24px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '146px', right: '2px' },
            styles: 'scale-[0.8] origin-bottom-right',
        },
        DoubleChanceButtonNoAmuseBoost: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '146px', right: '120px' },
        },
        DoubleChanceButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { top: '4px', right: '0px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '146px', right: '2px' },
            styles: 'scale-[0.8] origin-bottom-right',
        },
        BuyBonusButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { bottom: '17px', left: '0px' },
        },
        AmuseBoostButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '146px', right: '2px' },
            styles: 'scale-[0.8] origin-bottom-right',
        },
        AmuseBoostModal: {
            dimensions: { width: '132px', height: '274px' },
            position: { bottom: '260px', right: '-12px' },
            styles: 'scale-[0.8]',
        },
        PromoWidget: {
            position: { bottom: '146px', right: '126px' },
            dimensions: { width: '132px', height: '168px' },
            styles: 'scale-[0.8] origin-bottom-right',
        },
        Navigation: {
            styles: 'px-[10px] flex justify-between items-end',
            position: { bottom: '27px' },
        },
        NavigationLeftWrapper: {
            styles: '',
        },
        NavigationRightWrapper: {
            styles: 'flex gap-y-[20px] gap-x-[5px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[14px] leading-[18px]',
        },
        ComplianceColLeft: {
            styles: 'flex gap-[30px] flex-row-reverse',
        },
        ComplianceColCenter: {
            styles: 'flex gap-[30px]',
        },
        ComplianceColRight: {
            styles: 'flex gap-[30px]',
        },
        CustomResult: {
            position: { top: '176px', left: '5px' },
            styles: 'absolute w-[50px] h-[50px] z-[200]',
        },
        InfoLine: {
            position: { bottom: '130px' },
            styles: 'absolute h-[36px] w-[790px] flex justify-center items-center text-center translate-x-[-50%] left-[50%] bg-winline-gradient',
        },
        InfoLineJackpot: {
            position: { bottom: '87px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'w-full flex gap-[16px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        JackpotHistory: {
            position: { top: '72px' },
            dimensions: { height: '738px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '27px' },
        },
        BetStepper: {
            styles: 'absolute left-1/2 transfrom translate-x-[-50%]',
            position: { bottom: '30px' },
        },
    },
    [ViewportType.DESKTOP]: {
        SpinButtonSection: {
            dimensions: { width: '200px' },
            position: { bottom: '382px', right: '50px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonSectionLeftHand: {
            position: { bottom: '382px', right: '50px' },
        },
        SpinButtonGambleSection: {
            dimensions: { width: '200px' },
            position: { bottom: '425px', right: '50px' },
            styles: 'flex-col gap-[10px] items-center',
        },
        SpinButtonGambleSectionLeftHand: {
            position: { bottom: '382px', right: '50px' },
        },
        SpinButton: {
            styles: '',
        },
        StopButton: {
            position: { top: '112px', left: '289px' },
            styles: 'bg-black fixed w-[70%] h-[74%] z-[0]',
        },
        BetOptionButton: {
            styles: '',
        },
        BetOptionSection: {
            styles: 'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#131313]',
        },
        AutoplayButton: {
            styles: '',
        },
        AutoplaySection: {
            position: { top: '-7px', right: '180px' },
            styles: 'absolute bg-[#131313]',
        },
        AutoplaySectionLeftHand: {
            position: { top: '0', left: '180px' },
        },
        SpeedButton: {
            styles: 'z-[51] mt-[-25px] flex',
        },
        PlayerInfoWrapperClass: { styles: '' },
        PlayerInfoBalance: {
            position: { bottom: '33px', left: '286px' },
            dimensions: { width: '224px' },
        },
        PlayerInfoLastWin: {
            dimensions: { width: '224px' },
            position: { bottom: '33px', right: '296px' },
            styles: 'flex-col',
        },
        PlayerInfoWinLabel: {
            styles: '',
        },
        PlayerInfoCurrencyLabel: {
            styles: '',
        },
        PlayerInfoLastWinMoneyWrapper: {
            styles: 'flex flex-col items-center',
        },
        PlayerInfoExternalBetAmount: {
            styles: 'rounded-[100px] bg-black/50',
            position: { bottom: '33px', right: '874px' },
            dimensions: { width: '166px', height: '76px' },
        },
        PlayerInfoAdditionalWinAmount: {
            dimensions: { width: '172px' },
        },
        BetSlider: {
            position: { bottom: '30px' },
        },
        BetSliderArrowLeft: {
            position: { top: '4px', left: '-36px' },
        },
        BetSliderArrowRight: {
            position: { top: '4px', right: '-36px' },
        },
        DoubleChanceButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '178px', right: '8px' },
        },
        DoubleChanceButtonNoAmuseBoost: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '178px', right: '148px' },
        },
        DoubleChanceButtonCompact: {
            dimensions: { width: '132px', height: '127px' },
            position: { top: '4px', right: '0px' },
        },
        BuyBonusButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '178px', right: '8px' },
        },
        BuyBonusButtonCompact: {
            dimensions: { width: '132px', height: '127px' },

            position: { bottom: '17px', right: '0px' },
        },
        AmuseBoostButton: {
            dimensions: { width: '132px', height: '168px' },
            position: { bottom: '178px', right: '8px' },
        },
        AmuseBoostModal: {
            dimensions: { width: '132px', height: '274px' },
            position: { bottom: '351px', right: '8px' },
        },
        PromoWidget: {
            position: { bottom: '178px', right: '156px' },
            dimensions: { width: '132px', height: '168px' },
        },
        Navigation: {
            styles: 'px-[15px] flex justify-between',
            position: { bottom: '34px' },
        },
        NavigationLeftWrapper: {
            styles: 'flex gap-[10px]',
        },
        NavigationRightWrapper: {
            styles: 'flex gap-[10px]',
        },
        Compliance: {
            styles: 'px-[8px] flex justify-between text-[20px] leading-[24px]',
        },
        ComplianceColLeft: {
            styles: 'flex gap-[30px] flex-row-reverse',
        },
        ComplianceColCenter: {
            styles: 'flex gap-[30px]',
        },
        ComplianceColRight: {
            styles: 'flex gap-[30px]',
        },
        CustomResult: {
            position: { top: '233px', left: '5px' },
            styles: 'absolute w-[70px] h-[70px] z-[200]',
        },
        InfoLine: {
            position: { bottom: '132px' },
            styles: 'absolute h-[36px] w-[810px] flex justify-center items-center text-center translate-x-[-50%] left-[50%] bg-winline-gradient',
        },
        InfoLineJackpot: {
            position: { bottom: '97px' },
        },
        InfoLineWinLineWrapper: {
            styles: 'w-full flex gap-[16px] justify-center items-center',
        },
        InfoLineWinAmount: {
            styles: 'text-[24px] leading-[24px] text-white flex items-baseline font-bold',
        },
        InfoLineNumber: {
            styles: 'text-[24px] leading-[24px] text-white text-center font-bold',
        },
        InfoLineText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        InfoLineImageWrapper: {
            dimensions: { width: '36px', height: '36px' },
            styles: 'flex gap-[16px] items-center justify-center',
        },
        InfoLineFreespinText: {
            styles: 'text-[30px] leading-[36px] text-white text-center font-bold',
        },
        JackpotHistory: {
            position: { top: '94px' },
            dimensions: { height: '986px' },
        },
        RemainingSpinsBanner: {
            position: { bottom: '35px' },
        },
        BetStepper: {
            styles: 'absolute left-1/2 transfrom translate-x-[-50%]',
            position: { bottom: '37px' },
        },
    },
}
